import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, CheckBox, CheckBoxOutlineBlankOutlined, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../../components/FormikControl/FormikControl';
import { useAlert } from '../../../../../../context/AlertContext';
import { useAppData } from '../../../../../../context/AppDataContext';
import AwsImageInline from '../../../../../../components/InlineEdit/AwsImageInline';
import leadServices from '../leadServices';
import moment from 'moment/moment';


function LeadForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();

    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const [deadline,setDeadLine] = useState(false);

    const initialValues = {        
        businessName:"",
        interestedIn:"",
        estimatedValue:"",
        contactPerson1:"",
        contactPhone1:"",
        contactEmail1:"",
        contactPerson2:"",
        contactPhone2:"",
        contactEmail2:"",
        details:"",
        dueDate:moment().format("YYYY-MM-DD"),
        source:"",
        priority:1,
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            businessName:data.businessName,
            interestedIn:data.interestedIn,
            estimatedValue:data.estimatedValue,
            contactPerson1:data.contactPerson1,
            contactPhone1:data.contactPhone1,
            contactEmail1:data.contactEmail1,
            contactPerson2:data.contactPerson2,
            contactPhone2:data.contactPhone2,
            contactEmail2:data.contactEmail2,
            details:data.details,
            dueDate:data.dueDate||moment().format("YYYY-MM-DD"),
            source:data.source,
            priority:data.priority,
        }
        if(data.dueDate){
            setDeadLine(true);
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        businessName:Yup.string().required("Required"),
        interestedIn:Yup.string().required("Required"),
        contactPerson1:Yup.string().required("Required"),
        contactPhone1:Yup.string().matches(/^[0-9]+$/, "Phone number must contain only digits").length(10, "Phone number must be exactly 10 digits").required("Required"),
        contactEmail1:Yup.string().email('Invalid email format'),
        //contactPerson2:Yup.string().required("Required"),
        //contactPhone2:Yup.string().matches(/^[0-9]+$/, "Phone number must contain only digits").length(10, "Phone number must be exactly 10 digits"),
        //contactEmail2:Yup.string().email('Invalid email format'),
        //details:Yup.string().required("Required"),
        source:Yup.string().required("Required"),
        priority:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        let _values = {...values};
        if(!deadline){
            delete _values.dueDate;
        }

        setSavingStatus(true);
        leadServices.save(_values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> New Lead</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik);
                            return (
                                <Form>
                                    <DialogTitle>{"Lead"}</DialogTitle>
                                    <DialogContent>
                                        <div className="row">
                                            <div className="col-md-6 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Business Name *" name="businessName" 
                                                />
                                            </div>

                                            <div className="col-md-6 my-2" >
                                                <FormikControl control="autoselect" formik={formik}
                                                    options={masters['lead-source']}
                                                    label="Source" name="source"
                                                />
                                            </div>
                                            <div className="col-md-6 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Interested In *" name="interestedIn" 
                                                />
                                            </div>

                                            <div className="col-md-6 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Estimeted Value *" name="estimatedValue" 
                                                />
                                            </div>

                                            <div className='col-md-12'>
                                                <hr/>
                                                <div className='text-primary fw-bold'>Contact Details</div>

                                            </div>
                                            <div className="col-md-4 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Contact Person *" name="contactPerson1" 
                                                />
                                            </div>

                                            <div className="col-md-4 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Phone *" name="contactPhone1" 
                                                />
                                            </div>

                                            <div className="col-md-4 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Email" name="contactEmail1" 
                                                />
                                            </div>


                                            <div className='col-md-12'>
                                                <div className='text-info fw-bold'>Alternate Contact Details</div>
                                            </div>
                                            <div className="col-md-4 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Contact Person" name="contactPerson2" 
                                                />
                                            </div>

                                            <div className="col-md-4 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Phone" name="contactPhone2" 
                                                />
                                            </div>

                                            <div className="col-md-4 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Email" name="contactEmail2" 
                                                />
                                            </div>

                                            <div className="col-md-12 my-2" >
                                                <FormikControl control="input" formik={formik} type="text" multiline={true} rows={4}
                                                    label="Details / Remark *" name="details" 
                                                />
                                            </div>

                                            
                                            <div className='col-md-12'>
                                                <button type="button" className='btn btn-outline-primary' onClick={()=>setDeadLine(!deadline)} >
                                                    {deadline ?  <CheckBox /> : <CheckBoxOutlineBlankOutlined />  }
                                                    <span className='ms-2'>Deadline</span>
                                                </button>
                                            </div>
                                            <div className='col-md-12 mt-3'>
                                                {deadline &&
                                                    <FormikControl control="input" formik={formik} type="date"
                                                        label="Due Date" name="dueDate" 
                                                    />
                                                }
                                            </div>
                                            
                                            


                                            {data == null &&
                                            <div className="col-md-12 my-2" >
                                                <FormikControl control="radio" formik={formik}
                                                    options={masters['priority']}
                                                    label="Priority *" name="priority"
                                                />
                                            </div>
                                            }


                                        </div>
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" disabled={!formik.isValid}  type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik) */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default LeadForm